/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CompanyListFromJSON, CompanyListToJSON } from './CompanyList';
export function GetCompanyListsResponseDataFromJSON(json) {
    return GetCompanyListsResponseDataFromJSONTyped(json, false);
}
export function GetCompanyListsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyLists: !exists(json, 'company_lists')
            ? undefined
            : json['company_lists'].map(CompanyListFromJSON)
    };
}
export function GetCompanyListsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_lists: value.companyLists === undefined ? undefined : value.companyLists.map(CompanyListToJSON)
    };
}
